import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Link } from "react-router-dom";
import { Newspaper, ArrowRight } from "lucide-react";

export default function RevueDePresse() {
  return (
    <>
      <SEO
        title="Revue de presse — venteaterme.fr"
        description="Retrouvez prochainement les mentions de venteaterme.fr dans les médias économiques et immobiliers."
      />
      <section className="pt-24 pb-10 bg-navy text-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-accent-brand font-bold mb-4">Presse</div>
          <h1 className="font-serif text-4xl md:text-6xl leading-tight text-balance">Revue de presse</h1>
          <p className="text-cream/80 mt-6 max-w-3xl">La sélection des articles et mentions parus dans la presse spécialisée sera publiée ici — au fur et à mesure des parutions.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <Breadcrumbs items={[{ href: "/", label: "Accueil" }, { href: "/revue-de-presse", label: "Revue de presse" }]} />

          <div data-testid="empty-state-presse" className="bg-white border border-navy/10 p-10 md:p-14 text-center">
            <div className="mx-auto w-14 h-14 border border-accent-brand/40 bg-accent-brand/5 flex items-center justify-center mb-6">
              <Newspaper size={26} className="text-accent-brand" strokeWidth={1.4} />
            </div>
            <h2 className="font-serif text-2xl md:text-3xl text-navy mb-3 text-balance">La revue de presse arrive prochainement.</h2>
            <p className="text-navy/70 max-w-xl mx-auto leading-relaxed mb-8">
              Les premières publications qui traiteront de&nbsp;venteaterme.fr et de la vente à terme immobilière apparaîtront ici. Nous privilégions les mentions éditoriales indépendantes, sans partenariat commercial.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <Link to="/contact" data-testid="empty-state-presse-contact"
                className="inline-flex items-center justify-center gap-2 bg-accent-brand text-white px-6 py-3 text-sm font-bold tracking-wide hover:bg-[#B08D22] transition-colors">
                Contact presse & médias <ArrowRight size={16} />
              </Link>
              <Link to="/blog" data-testid="empty-state-presse-guides"
                className="inline-flex items-center justify-center gap-2 border border-navy text-navy px-6 py-3 text-sm font-bold tracking-wide hover:bg-navy hover:text-cream transition-colors">
                Lire nos guides
              </Link>
            </div>
          </div>

          <p className="text-xs text-navy/50 italic pt-6 text-center">Aucune relation commerciale n’est établie avec les médias qui pourraient citer&nbsp;venteaterme.fr.</p>
        </div>
      </section>
    </>
  );
}
